import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { useUpdateUser } from '@modules/common/hooks/useUpdateUser';
import { useUserManagementStore } from '@modules/users/store/hooks';
import { UserManagementActionType } from '@modules/users/store/userManagementActionType';
import { UserState } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

export const useUpdateUserState = () => {
  const { showSuccessNotification, showErrorNotification } =
    useNotificationContext();

  const dispatch = useUserManagementStore(({ dispatch }) => dispatch);

  const { updateUser, loading } = useUpdateUser({
    shouldShowErrorToast: false,
  });

  const updateUserState = async (
    id: UUID,
    updatedState: UserState,
    email: string,
  ) => {
    const isBeingSuspended = updatedState === UserState.Suspended;
    try {
      await updateUser({
        state: updatedState,
        id,
      });
      dispatch({
        type: UserManagementActionType.UPDATE_USER,
        payload: {
          id,
          user: {
            state: updatedState,
          },
        },
      });
      showSuccessNotification({
        contentComponent: `${
          isBeingSuspended ? 'Suspended' : 'Reactivated'
        } ${email}`,
        props: {},
      });
    } catch {
      showErrorNotification({
        contentComponent: `Failed to ${
          isBeingSuspended ? 'Suspend' : 'Reactivate'
        } ${email}`,
        props: {},
      });
    }
  };

  return { updateUserState, isLoading: loading };
};
